import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
import IconContainer from '../../common/IconContainer';
export const FaqContainer = styled(IconContainer) `
  &:not(:first-child) {
    border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
  }
`;
export const FaqHeaderContainer = styled.div `
  max-width: 430px;
  width: 100%;

  padding-block-start: ${({ theme }) => theme.spacing.lg}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;

  ${media.md `
    gap: ${({ theme }) => theme.spacing.xs}px;
  `}
`;
export const FAQContentContainer = styled.div `
  .ReactCollapse--content {
    padding: 0;
  }
  ul,
  ol {
    li {
      & * {
        display: inline;
      }
    }
  }
`;
